angular.module('impactx.rfx').controller('RFXLastValidDateConfirm', RFXLastValidDateConfirm);

RFXLastValidDateConfirm.$inject = [
    '$scope',
    '$mdDialog'
];

function RFXLastValidDateConfirm($scope, $mdDialog) {
    var self = this;

    self.sendWithoutChange = function () {
        $mdDialog.hide({changeDate: false});
    };

    self.changeDateAndSend = function () {
        $mdDialog.hide({changeDate: true});
    };

    self.abort = function () {
        $mdDialog.cancel();
    };
}